/**
 * @generated SignedSource<<80c7951914f1016bfe3fdf4321c75fd5>>
 * @relayHash 395ef377c8fc50a877abe4ee0c990076
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/547.0.0-2026-02-18T18:18:27.789Z/loadAppDownloadItemSavedModalQuery

import { ConcreteRequest } from 'relay-runtime';
export type loadAppDownloadItemSavedModalQuery$variables = {
  daysSinceUsedApp: number;
  userId: string;
};
export type loadAppDownloadItemSavedModalQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly hasUsedAppInLastDays: boolean | null;
    } | null;
  };
};
export type loadAppDownloadItemSavedModalQuery = {
  response: loadAppDownloadItemSavedModalQuery$data;
  variables: loadAppDownloadItemSavedModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "daysSinceUsedApp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "days",
      "variableName": "daysSinceUsedApp"
    }
  ],
  "kind": "ScalarField",
  "name": "hasUsedAppInLastDays",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "loadAppDownloadItemSavedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loadAppDownloadItemSavedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/547.0.0-2026-02-18T18:18:27.789Z/loadAppDownloadItemSavedModalQuery",
    "metadata": {},
    "name": "loadAppDownloadItemSavedModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "369401005781710a51e82e3964de39f5";

export default node;
